import { z } from 'zod'

/** Represents the enum public.cable_lock_event_status_ */
enum CableLockEventStatus {
  pending = 'pending',
  bom_submitted = 'bom_submitted',
  serials_created = 'serials_created',
  so_updated = 'so_updated',
  completed = 'completed',
  failed = 'failed',
}

export default CableLockEventStatus

/** Zod schema for cable_lock_event_status_ */
export const cableLockEventStatus = z.enum([
  'pending',
  'bom_submitted',
  'serials_created',
  'so_updated',
  'completed',
  'failed',
])
